module.exports = __webpack_public_path__ + "img/rest-message.6c346098.png";